import { render } from "./AccessRequestEditor.vue?vue&type=template&id=944cd5f2"
import script from "./AccessRequestEditor.vue?vue&type=script&lang=js"
export * from "./AccessRequestEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__